<template>
  <div>
    <v-row class="primary pb-2 pt-5" no-gutters>
      <v-col cols="12" class="white--text">
        <h2>Become a supplier</h2>
        <p>Create an account and start selling your products.</p>
      </v-col>
    </v-row>

    <v-row class="">
      <v-col cols="12" class="primary--text">
        <p class="mb-0 px-2">
          <span class="font-weight-medium">Select the type of your activity:</span>
          <br>
          If you're registering a company please select Business, otherwise select Independent.
        </p>
      </v-col>
    </v-row>

    <app-alert-error v-if="error" @dismissed="onDismiss" :text="error.message"></app-alert-error>

    <v-form @submit.prevent="onRegisterSupplier" ref="form" v-model="valid">
      <v-card flat>
        <v-card-text>
          <v-row no-gutters>
            <v-col align="start" cols="12" sm="2">
              <div class="mt-2">Type: </div>
            </v-col>
            <v-col  cols="12" sm="10">
              <v-select v-model="type" :rules="validType" :items="supplierTypes" dense required outlined></v-select>
            </v-col>
          </v-row>
          <template v-if="type === 'Independent'">
            <v-row no-gutters>
              <v-col cols="12" sm="5">
                <v-text-field label="First Name" name="firstName" type="text" :rules="fieldRules('First Name', 30)" v-model="indSupplier.firstName" dense required outlined></v-text-field>
              </v-col>
              <v-col align="start" cols="12" sm="6" offset-sm="1">
                <v-text-field label="Last Name" name="lastName" type="text" :rules="fieldRules('Last Name', 30)" v-model="indSupplier.lastName" dense required outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field label="Phone Number" name="phoneNumber" type="tel" :rules="fieldRules('Phone Number', 20)" v-model="indSupplier.phoneNumber" dense required outlined></v-text-field>
                <v-text-field label="E-mail" name="email" type="email" v-model="indSupplier.email" dense required outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="5">
                <v-text-field label="Password" name="password" :type="showPassword ? 'text' : 'password'" v-model="password" :rules="fieldRules('Password', 20)" dense required outlined></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" offset-sm="1">
                <v-text-field label="Confirm Password" name="password" :type="showPassword ? 'text' : 'password'" :append-outer-icon="showPassword ? 'visibility' : 'visibility_off'" @click:append-outer="showPassword = !showPassword" v-model="confirmPassword" :rules="comparePasswords" dense required outlined></v-text-field>
              </v-col>
            </v-row>
          </template>

          <template v-if="type === 'Business'">
            <v-row no-gutters>
              <v-col cols="12" sm="5">
                <v-text-field label="First Name" name="firstName" type="text" :rules="fieldRules('First Name', 30)" v-model="busSupplier.firstName" dense required outlined></v-text-field>
              </v-col>
              <v-col align="start" cols="12" sm="6" offset-sm="1">
                <v-text-field label="Last Name" name="lastName" type="text" :rules="fieldRules('Last Name', 30)" v-model="busSupplier.lastName" dense required outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field label="Phone Number" name="phoneNumber" type="tel" :rules="fieldRules('Phone Number', 20)" v-model="busSupplier.phoneNumber" dense required outlined></v-text-field>
                <v-text-field label="E-mail" name="email" type="email" v-model="busSupplier.email" dense required outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="11" sm="4">
                <v-text-field label="Position" name="position" type="text" :rules="fieldRules('Position', 50)" v-model="busSupplier.position" dense required outlined></v-text-field>
              </v-col>
              <v-col cols="1" sm="1" class="mt-1">
                <ShowInfo icon="info" infoText="The position in company of the person who will be managing this account" />
              </v-col>
              <v-col cols="12" sm="6" offset-sm="1">
                <v-text-field label="Company Name" name="compnay-name" type="text" :rules="fieldRules('Company Name', 50)" v-model="busSupplier.companyName" dense required outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field label="Company Website (optional)" name="website" type="url" v-model="busSupplier.website" dense outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="11">
                <v-text-field label="Registration Number" name="reg-nb" type="text" :rules="fieldRules('Registration Number', 50)" v-model="busSupplier.companyRegNb" dense required outlined></v-text-field>
              </v-col>
              <v-col cols="1" class="mt-1">
                  <ShowInfo icon="info" infoText="Company Registration Number" />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="5">
                <v-text-field label="Password" name="password" :type="showPassword ? 'text' : 'password'" v-model="password" :rules="fieldRules('Password', 20)" dense required outlined></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" offset-sm="1">
                <v-text-field label="Confirm Password" name="password" :type="showPassword ? 'text' : 'password'" :append-outer-icon="showPassword ? 'visibility' : 'visibility_off'" @click:append-outer="showPassword = !showPassword" v-model="confirmPassword" :rules="comparePasswords" dense required outlined></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions v-if="type" class="pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn depressed class="grey darken-1 white--text" to="/">Cancel</v-btn>
          <v-btn v-if="!isLoading" depressed class="farmer_green white--text" type="submit">
            Register
          </v-btn>
          <v-btn v-else loading depressed type="submit" disabled>
            Register
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
 </div>
</template>

<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  components: { ShowInfo: () => import('@/components/shared/ShowInfo') },

  data() {
    return {
      type: '',
      isLoading: false,
      valid: true,
      showPassword: false,
      password: '',
      confirmPassword: '',
      supplierTypes: ['Independent', 'Business'],
      indSupplier: {},
      busSupplier: {},
      tempPass: '',
      snackbar: false,
      timeout: 2000,
      snackbarText: ''
    }
  },
  computed: {
    ...mapGetters(['error']),
    fieldRules() {
      return (fieldName, maxChar) => [
        v => (!!v && !!v.trim()) || `${fieldName} is required`,
        v =>
          (v && v.length <= maxChar) ||
          `${fieldName} must be less than ${maxChar} characters`
      ]
    },
    validType() {
      return [
        v => !!v || 'Type is required',
        v =>
          v === 'Independent' ||
          v === 'Business' ||
          "Type can only take one of this valus 'independent', 'business'"
      ]
    },
    comparePasswords() {
      return [p => p === this.password || 'Passwords do not match']
    }
  },
  methods: {
    onRegisterSupplier() {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        /**
         * supplier type must be in lowercase
         * that's why we call `toLowerCase()` on `this.type`
         */
        if (this.type === 'Independent') {
          const supplier = { ...this.indSupplier, type: this.type.toLowerCase(), password: this.password }
          store.dispatch('registerIndSupplier', supplier)
            .then(() => {
              this.isLoading = false
            })
            .catch(err => {
              this.isLoading = false
              store.commit('setError', err)
            })
        } else if (this.type === 'Business') {
          const supplier = { ...this.busSupplier, type: this.type.toLowerCase(), password: this.password }
          store.dispatch('registerBusSupplier', supplier)
            .then(() => {
              this.isLoading = false
            })
            .catch(err => {
              this.isLoading = false
              store.commit('setError', err)
            })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
